import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4 mb-3" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = {
  key: 0,
  class: "col-md-4 mb-3"
}
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = {
  key: 1,
  class: "col-md-4 mb-3"
}
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = {
  key: 2,
  class: "col-md-4 mb-3"
}
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = {
  key: 3,
  class: "col-md-4 mb-3"
}
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = {
  key: 4,
  class: "col-md-4 mb-3"
}
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = {
  key: 5,
  class: "col-md-4 mb-3"
}
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = {
  key: 6,
  class: "col-md-4 mb-3"
}
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = {
  key: 7,
  class: "col-md-4 mb-3"
}
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = {
  key: 8,
  class: "col-md-4 mb-3"
}
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "col-md-4 mb-3" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_27 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_28 = {
  key: 9,
  class: "col-md-4 mb-3"
}
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = { class: "col-md-4 mb-4" }
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_32 = {
  key: 10,
  class: "col-md-12 mb-3"
}
const _hoisted_33 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_34 = {
  key: 11,
  class: "col-md-4 mb-3"
}
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_36 = {
  key: 12,
  class: "col-md-4 mb-3"
}
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_38 = { class: "col-md-4 mb-3" }
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_40 = { class: "col-md-4 mb-3" }
const _hoisted_41 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_42 = { class: "col-md-4 mb-3" }
const _hoisted_43 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_44 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_45 = { class: "col-md-4 mb-3" }
const _hoisted_46 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_47 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_48 = {
  key: 13,
  class: "col-md-4 mb-3"
}
const _hoisted_49 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_50 = {
  key: 14,
  class: "col-md-4 mb-3"
}
const _hoisted_51 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_52 = {
  key: 15,
  class: "col-md-4 mb-3"
}
const _hoisted_53 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_54 = {
  key: 16,
  class: "col-md-4 mb-3"
}
const _hoisted_55 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_56 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_57 = { class: "col-md-4 mb-3" }
const _hoisted_58 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_59 = {
  key: 17,
  class: "col-md-4 mb-3"
}
const _hoisted_60 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_61 = {
  key: 18,
  class: "col-md-4 mb-3"
}
const _hoisted_62 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_63 = { class: "col-md-12 mt-3" }
const _hoisted_64 = { class: "d-flex align-items-center" }
const _hoisted_65 = {
  ref: "submitButton",
  class: "btn btn-success me-3",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Ajouter un client")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "clientForm",
        onSubmit: _ctx.addClient,
        "validation-schema": _ctx.clientSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Statut"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "statut",
                  modelValue: _ctx.defaultStatut,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.defaultStatut) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.statut,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      placeholder: "Sélectionner le statut",
                      onSelect: _ctx.handleObjetInput
                    }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "statut",
                class: "text-danger"
              })
            ]),
            (_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Nom du client "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "nomClient",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le nom"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "nomClient",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Prénom du client"),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "prenomClient",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le prenom"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "prenomClient",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Civilité "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "civilite" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: ['M.', 'Mme'],
                          searchable: true,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner la civilité" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "civilite",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Type de pièce "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "piece" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.pieceOptions,
                          searchable: true,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner le type de pièce" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "piece",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Numéro de pièce : "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "numeroPiece",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le numéro de pièce"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "numeroPiece",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Date d'expiration"),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "dateExpiration",
                      type: "date",
                      min: _ctx.currentDate,
                      class: "form-control shadow-none fs-md-15 text-black"
                    }, null, 8, ["min"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "dateExpiration",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Sigle ", -1)),
                    _createVNode(_component_Field, {
                      name: "sigle",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le sigle"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "sigle",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Nom Commercial ", -1)),
                    _createVNode(_component_Field, {
                      name: "nomCommercial",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le nom commercial"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "nomCommercial",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Raison sociale "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "raisonSociale",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer la raison sociale"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "raisonSociale",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, [
                  _cache[18] || (_cache[18] = _createTextVNode(" IFU ")),
                  (!_ctx.showAdditionalFields)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_Field, {
                  name: "ifu",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer l'ifu"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "ifu",
                  class: "text-danger"
                })
              ])
            ]),
            (!_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Régistre de commerce "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "rccm",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le régistre de commerce"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "rccm",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                  _createTextVNode(" Pays de résidence "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "paysResidence",
                  modelValue: _ctx.pay,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pay) = $event)),
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.pays,
                      searchable: true,
                      placeholder: "Sélectionner le pays de résidence",
                      label: "label",
                      "track-by": "label"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "paysResidence",
                  class: "text-danger"
                })
              ])
            ]),
            (_ctx.pay == 'Bénin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Quartier de résidence"),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "quartier" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          placeholder: "Rechercher un quartier",
                          "filter-results": false,
                          "min-chars": 2,
                          "resolve-on-load": false,
                          delay: 0,
                          searchable: true,
                          "options-limit": 300,
                          options: async (query) => {
                    return await _ctx.fechQuartiers(query)
                  },
                          "no-options-text": _ctx.noOptionsTextQuatier
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "no-options-text"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "quartier",
                    class: "text-danger"
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.pay != 'Bénin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Région de résidence"),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "region",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer votre région"
                    })
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "region",
                    class: "text-danger"
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.pay != 'Bénin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Ville de résidence"),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "ville",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer votre ville"
                    })
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "ville",
                    class: "text-danger"
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Adresse complète "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "adresseClient",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Ex: Non loin de ..."
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "adresseClient",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Email ", -1)),
                _createVNode(_component_Field, {
                  name: "emailClient",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer l'email"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "emailClient",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Téléphone 1 "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "telephone1" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_vue_tel_input, _mergeProps({
                      placeholder: "Entrer le numéro de téléphone",
                      modelValue: _ctx.telephone1,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.telephone1) = $event))
                    }, field, {
                      defaultCountry: "BJ",
                      mode: "international",
                      onValidate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validatePhone($event, 'telephone1'))),
                      class: "shadow-none fs-md-15 text-black py-2"
                    }), null, 16, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.telephone1 && !_ctx.validPhone.telephone1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, "Veuillez entrer un numéro correct "))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "telephone1",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Téléphone 2 ", -1)),
                _createVNode(_component_Field, { name: "telephone2" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_vue_tel_input, _mergeProps({
                      placeholder: "Entrer le numéro de téléphone",
                      modelValue: _ctx.telephone2,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.telephone2) = $event))
                    }, field, {
                      defaultCountry: "BJ",
                      mode: "international",
                      onValidate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validatePhone($event, 'telephone2'))),
                      class: "shadow-none fs-md-15 text-black py-2"
                    }), null, 16, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.telephone2 && !_ctx.validPhone.telephone2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, "Veuillez entrer un numéro correct "))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "telephone2",
                  class: "text-danger"
                })
              ])
            ]),
            (_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de naissance ", -1)),
                    _createVNode(_component_Field, {
                      name: "dateNais",
                      type: "date",
                      max: _ctx.currentDate,
                      class: "form-control shadow-none fs-md-15 text-black"
                    }, null, 8, ["max"])
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "dateNais",
                    class: "text-danger"
                  })
                ]))
              : _createCommentVNode("", true),
            (!_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de création ", -1)),
                    _createVNode(_component_Field, {
                      name: "dateCreation",
                      type: "date",
                      max: _ctx.currentDate,
                      class: "form-control shadow-none fs-md-15 text-black"
                    }, null, 8, ["max"])
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "dateCreation",
                    class: "text-danger"
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Nom et Prénoms de la personne à contacter "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "personneAContacter",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le nom et les prénoms du contact"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "personneAContacter",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _cache[31] || (_cache[31] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Téléphone de la personne à contacter "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "telephonePersonneAContacter" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_vue_tel_input, _mergeProps({
                          placeholder: "Entrer le numéro de téléphone",
                          modelValue: _ctx.telephonePersonneAContacter,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.telephonePersonneAContacter) = $event))
                        }, field, {
                          defaultCountry: "BJ",
                          mode: "international",
                          onValidate: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validatePhone($event, 'telephonePersonneAContacter'))),
                          class: "shadow-none fs-md-15 text-black py-2"
                        }), null, 16, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.telephonePersonneAContacter && !_ctx.validPhone.telephonePersonneAContacter)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, " Veuillez entrer un numéro correct"))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ErrorMessage, {
                      name: "telephonePersonneAContacter",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Catégorie du client"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "categorieClient" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.categorieClientOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner la catégorie du client" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "categorieClient",
                  class: "text-danger"
                })
              ])
            ]),
            (!_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Promoteur "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "promoteur" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                          options: _ctx.clientOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          placeholder: "Sélectionner le promoteur"
                        }, field), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "promoteur",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.showAdditionalFields)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _cache[34] || (_cache[34] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Gérant "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "gerant" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                          options: _ctx.clientOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          placeholder: "Sélectionner le gérant"
                        }, field), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "gerant",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("button", _hoisted_65, " Ajouter un client ", 512),
                _createVNode(_component_router_link, {
                  to: "/clients/liste-clients",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[35] || (_cache[35] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}